const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
const token = match ? match[2] : null;
export const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + token,
    'Who': 'Bearer ' + token,
};
